import axiosClient from "./axiosClient";

export const homeApi = {
    getHistoryLog: () =>{
        const url = "/api/history-log";
        return axiosClient.get(url);
    }
};